import { render, staticRenderFns } from "./IntlPhone.vue?vue&type=template&id=1d2dba36&scoped=true&"
import script from "./IntlPhone.vue?vue&type=script&lang=ts&"
export * from "./IntlPhone.vue?vue&type=script&lang=ts&"
import style0 from "./IntlPhone.vue?vue&type=style&index=0&id=1d2dba36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2dba36",
  null
  
)

export default component.exports